import {logEvent} from 'analytics';
import {gtmAppTabView} from 'utils/gtm';
import type {Announcement} from './index';

export const humanizerV2: Announcement = {
    id: 'humanizer-v2',
    audience: root => root.user.humanizerAvailable,
    copy: {
        eyebrow: 'announcement-humanizer-v2-eyebrow',
        title: 'announcement-humanizer-v2-title',
        subtitle: 'announcement-humanizer-v2-subtitle',
        features: [
            'announcement-humanizer-v2-feature-scan',
            'announcement-humanizer-v2-feature-modes',
            'announcement-humanizer-v2-feature-free',
        ],
        cta: 'announcement-humanizer-v2-cta',
    },
    image: {
        desktop: '/announcements/humanizer-v2.webp',
        mobile: '/announcements/humanizer-v2-mobile.webp',
    },
    // An empty Humanizer, not the scan adopted into it: adopting replaces whatever the
    // user has left in its panes.
    onCta: root => {
        root.layout.setWorkspace('humanizer');
        logEvent(gtmAppTabView({tab_name: 'humanizer', page_type: 'app_scan', entrypoint: 'announcement'}));
    },
};
